import React from "react";
import LogsServerFRConfigurationsCard from "./LogsServerFRConfigurationsCard";
import VisitorVisitingHoursFRConfigurationsCard from "./VisitorVisitingHoursFRConfigurationsCard";
import GroupsSchedulesFRConfigurationsCard from "./GroupsSchedulesFRConfigurationsCard";
import FaceRecognitionFRConfigurationsCard from "./FaceRecognitionFRConfigurationsCard";
import DeviceTimeFRConfigurationsCard from "./DeviceTimeFRConfigurationsCard";
import ValidatePhotoFRConfigurationsCard from "./ValidatePhotoFRConfigurationsCard";
import KioskCheckInFlowConfigurationsCard from "./KioskCheckInFlowConfigurationsCard";

interface FRConfigurationsCardProps {
  selectedDeviceIPAddresses: string[];
}

const FRConfigurationsCard = ({
  selectedDeviceIPAddresses,
}: FRConfigurationsCardProps) => {
  return (
    <div className="bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)] flex flex-col  gap-3 lg:gap-6">
      <LogsServerFRConfigurationsCard
        selectedDeviceIPAddresses={selectedDeviceIPAddresses}
      />
      <VisitorVisitingHoursFRConfigurationsCard />
      <GroupsSchedulesFRConfigurationsCard
        selectedDeviceIPAddresses={selectedDeviceIPAddresses}
      />
      <FaceRecognitionFRConfigurationsCard
        selectedDeviceIPAddresses={selectedDeviceIPAddresses}
      />
      <DeviceTimeFRConfigurationsCard
        selectedDeviceIPAddresses={selectedDeviceIPAddresses}
      />
      <ValidatePhotoFRConfigurationsCard />
      {/* <ExternalApplyPassStepsFRConfigurationsCard /> */}
      <KioskCheckInFlowConfigurationsCard />
    </div>
  );
};

export default React.memo(FRConfigurationsCard);
